// "More in this design" (prompt 95): the (i) on a product card (blocks/ssc-card-offer.liquid) opens the design's other
// cuts. Phones: bottom sheet (grab handle, swipe down / tap outside / ✕ / Esc closes). From 990px: a popover next to the
// card. One <dialog> (modal, so focus stays inside), filled on tap only from /products/<handle>?section_id=ssc-design-family
// (cached per product); focus goes back to the (i) on close.
(function () {
  let dlg = null;
  let opener = null;
  const cache = new Map();
  const wide = () => window.matchMedia('(min-width: 990px)').matches;

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'ssc-fam-dlg';
    dlg.setAttribute('aria-labelledby', 'ssc-fam-title');
    dlg.innerHTML = '<span class="ssc-fam-dlg__grab" aria-hidden="true"></span><div class="ssc-fam-dlg__body" data-ssc-fam-body></div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg || (e.target instanceof Element && e.target.closest('[data-ssc-fam-close]'))) close();
    });
    dlg.addEventListener('close', () => {
      document.documentElement.classList.remove('ssc-fam-open');
      if (opener && document.contains(opener)) {
        // Focus goes back to the (i), without the card hearing it: Horizon's card prefetches its product page on focusin
        // and would start a second fetch that cancels its first (a console error, no use to the shopper).
        opener.addEventListener('focusin', (e) => e.stopPropagation(), { once: true });
        opener.focus({ preventScroll: true });
      }
      opener = null;
    });
    // Swipe down on the sheet (phones) closes it; the rail keeps its sideways scroll.
    let y0 = null;
    dlg.addEventListener('touchstart', (e) => {
      if (wide() || (e.target instanceof Element && e.target.closest('.ssc-fam__rail'))) { y0 = null; return; }
      y0 = e.touches[0].clientY;
    }, { passive: true });
    dlg.addEventListener('touchmove', (e) => {
      if (y0 === null) return;
      const dy = e.touches[0].clientY - y0;
      if (dy > 0) dlg.style.transform = `translateY(${dy}px)`;
    }, { passive: true });
    dlg.addEventListener('touchend', (e) => {
      if (y0 === null) return;
      const dy = (e.changedTouches[0] ? e.changedTouches[0].clientY : y0) - y0;
      dlg.style.transform = '';
      y0 = null;
      if (dy > 70) close();
    });
  }

  function close() {
    if (dlg && dlg.open) dlg.close();
  }

  function place(card) {
    dlg.classList.toggle('is-pop', wide());
    dlg.style.left = dlg.style.top = '';
    if (!wide() || !card) return;
    const r = card.getBoundingClientRect();
    const w = Math.min(520, window.innerWidth - 32);
    const h = dlg.offsetHeight || 360;
    let left = r.left + r.width / 2 - w / 2;
    left = Math.max(16, Math.min(left, window.innerWidth - w - 16));
    let top = r.top + 40;
    top = Math.max(16, Math.min(top, window.innerHeight - h - 16));
    dlg.style.left = `${Math.round(left)}px`;
    dlg.style.top = `${Math.round(top)}px`;
  }

  async function load(url) {
    if (cache.has(url)) return cache.get(url);
    const p = fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=ssc-design-family`, { headers: { Accept: 'text/html' } })
      .then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const node = doc.querySelector('[data-ssc-fam-content]');
        if (!node) throw new Error('no family');
        return node.outerHTML;
      });
    cache.set(url, p);
    p.catch(() => cache.delete(url));
    return p;
  }

  async function open(btn) {
    if (!dlg) build();
    opener = btn;
    const body = dlg.querySelector('[data-ssc-fam-body]');
    body.innerHTML = '<div class="ssc-fam is-loading"><div class="ssc-fam__head"><div><span class="ssc-fam__k">More in this design</span><h2 class="ssc-fam__title" id="ssc-fam-title">Loading…</h2></div><button type="button" class="ssc-fam__x" data-ssc-fam-close aria-label="Close">✕</button></div><div class="ssc-fam__rail"><span class="ssc-fam-mini is-ghost"></span><span class="ssc-fam-mini is-ghost"></span><span class="ssc-fam-mini is-ghost"></span></div></div>';
    const card = btn.closest('product-card, .product-card, li');
    document.documentElement.classList.add('ssc-fam-open');
    if (!dlg.open) dlg.showModal();
    place(card);
    try {
      body.innerHTML = await load(btn.dataset.sscFamily);
    } catch (e) {
      body.querySelector('#ssc-fam-title').textContent = "Couldn't load the other styles";
      body.querySelector('.ssc-fam__rail').remove();
    }
    place(card);
    const first = body.querySelector('.ssc-fam-mini:not(.is-here)') || body.querySelector('[data-ssc-fam-close]');
    if (first) first.focus({ preventScroll: true });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target instanceof Element ? e.target.closest('[data-ssc-family]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn);
  }, true);
  window.addEventListener('resize', () => { if (dlg && dlg.open) place(opener && opener.closest('product-card, .product-card, li')); });
})();
